import { Container } from '@zurich/ui/legacy/components';
import { styled } from '@zurich/ui/legacy/utils';

interface LayoutProps {
  children: JSX.Element[] | JSX.Element;
  disableSidebar?: boolean;
  loading: boolean;
}

export const Layout = ({ children }: LayoutProps) => {
  return (
    <PageWrapperStyled>
      <MainContentStyled>
        <Container maxWidth="lg" spacing={0}>
          {children}
        </Container>
      </MainContentStyled>
    </PageWrapperStyled>
  );
};

const PageWrapperStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  minHeight: '100vh',
  height: '100%',
  flexDirection: 'column',
  backgroundColor: theme.palette.groupPrimary.aliceBlue,
}));

const MainContentStyled = styled('main')(({ theme }) => ({
  flex: 1,
  padding: theme.spacing(10, 0),
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(2, 0),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2, 0),
  },
}));
